<template>
  <div>
    <div class="view-container">
      <div class="view-title">Tokyo Gakugei University</div>
      <div class="view-main">
        <iframe width="960" height="480" src="https://www.youtube.com/embed/juiup6jpA0k?si=Oi6LFJmHUWCcbOUg" title="An Overview of Tokyo Gakugei University" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <div class="view-text">
          <p>Tokyo Gakugei University (TGU) is Japan’s largest and most prestigious university dedicated to teacher education. Established in 1949, TGU has played a vital role in developing the nation’s education system and is widely recognized as a flagship institution in teacher training.</p>
          <p>TGU offers a full spectrum of academic programs, including undergraduate, master’s, and doctoral degrees, ensuring comprehensive training for educators and researchers.</p>
          <p>A distinctive feature of TGU is its network of <strong>12 affiliated schools</strong> located across five campuses in Tokyo. These schools play a significant role in integrating theory with practice, serving as venues for research, teacher training, and innovative educational development.</p>
          <p>The main campus in Koganei City is well-equipped with modern facilities, providing an ideal environment for research, collaboration, and academic excellence.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TGUView'
}
</script>

<style scoped></style>
